module.exports = __webpack_public_path__ + "static/garage-1-837d78ce7bda830c758690f4544f255c.jpg";